import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import Arrival from '../views/Arrival.vue'
import ArrivalForm from '../views/ArrivalForm.vue'
import ArrivalList from '../views/ArrivalList.vue'
import Account from '../views/Account.vue'
import Store from '../views/Store.vue'
import ProductForm from '../views/ProductForm.vue'
import ProductList from '../views/ProductList.vue'
import ReferencePage from '../views/ReferencePage.vue'
import WorkSchedulePlan from '../views/WorkSchedulePlan.vue'
import WorkScheduleFact from '../views/WorkScheduleFact.vue'
import WorkingHours from '../views/WorkingHours.vue'
import PayrollReport from '../views/PayrollReport.vue'
import WriteOffProducts from '../views/WriteOffProducts.vue'
import Employee from '../views/Employee.vue'
import SignUp from '../views/SignUp.vue'
import MainPage from '../views/MainPage.vue'
import NotFound from '../views/NotFound.vue'
import Sales from '../views/Sales.vue'
import StorePriceByDay from '../views/StorePriceByDay.vue'
import OrderTypePrice from '../views/OrderTypePrice.vue'
import Clients from '../views/Clients.vue'
import ClientReminders from '../views/ClientReminders.vue'
import Order from '../views/Order.vue'
import CreateShowcase from '../views/CreateShowcase.vue'
import Showcase from '../views/Showcase.vue'
import Dashboard from '../views/Dashboard.vue'
import Analytics from '../views/Analytics.vue'
import DashboardFlorist from '../views/DashboardFlorist.vue'

const routes:RouteRecordRaw[] = [
  { path: '/', name:"MainPage", component: MainPage, meta: { requiresAuth: false}},
  { path: '/showcase', name: 'Showcase', component: Showcase, meta: { requiresAuth: true, role: ['admin', 'employee']}},
  { path: '/create-showcase', name: 'CreateShowcase', component: CreateShowcase, meta: { requiresAuth: true, role: 'employee'}},
  { path: '/sign-up', name: 'SignUp', component: SignUp, meta: { requiresAuth: true, role: 'admin'}},
  // { path: '/mining', component: Mining },
  { path: '/account', name: 'Account', component: Account, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/account-report', redirect: '/account', meta: { requiresAuth: true, role: 'admin'}},
  { path: '/arrival',  name: 'Arrival', component: Arrival, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/arrival-list/:id', name: 'ArrivalList', component: ArrivalList, props: true, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/arrival-form', name: 'ArrivalForm', component: ArrivalForm, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/store', component: Store, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/store-price-by-day', name: 'StorePriceByDay', component: StorePriceByDay, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/product-type-price', name: 'OrderTypePrice', component: OrderTypePrice, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/clients', name: 'Clients', component: Clients, meta: { requiresAuth: true, role: ['admin', 'employee']}},
  { path: '/client-reminders', name: 'ClientReminders', component: ClientReminders, meta: { requiresAuth: true, role: ['admin', 'employee']}},
  { path: '/order/:id', name: 'Order', component: Order, props: true, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/product', component: ProductForm, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/products', component: ProductForm, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/reference-page', component: ReferencePage, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/write-off-products', name: 'WriteOffProducts', component: WriteOffProducts, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/employee', name: 'Employee', component: Employee, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/working-hours', name: 'WorkingHours', component: WorkingHours, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/work-schedule-plan', name: 'WorkSchedulePlan', component: WorkSchedulePlan, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/work-schedule-fact', name: 'WorkScheduleFact', component: WorkScheduleFact, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/payroll-report', name: 'PayrollReport', component: PayrollReport, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/dashboard', name: 'Dashboard', component: Dashboard, meta: { requiresAuth: true, role: ['admin', 'employee']}},
  { path: '/dashboard-florist', name: 'DashboardFlorist', component: DashboardFlorist, meta: { requiresAuth: true, role: ['admin', 'employee']}},
  { path: '/analytics', name: 'Analytics', component: Analytics, meta: { requiresAuth: true, role: 'admin'}},
  { path: '/sale', name: 'Sale', component: Sales, meta: { requiresAuth: true, role: ['admin', 'employee']}},
  { path: '/product-list', component: ProductList, meta: { requiresAuth: true, role: ['admin', 'employee']}},
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// router.beforeEach((_to, _from, next) => {
  // return next()
  // const auth = useAuthStore()
  // if (to.meta.requiresAuth && !auth.isAuthenticated) {
  //   next('/login')
  // } else if (to.meta.role && auth.user?.role !== to.meta.role) {
  //   next('/') // redirect if role doesn’t match
  // } else {
  //   next({ name: 'NotFound' })
  // }
// })

router.beforeEach((to, _from, next) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');

  if (to.meta.requiresAuth && !token) {
    // Неавторизованный
    return next({ name: 'Login' });
  }

  if (to.meta.role) {
    const allowedRoles = Array.isArray(to.meta.role) ? to.meta.role : [to.meta.role]
    if (!role || !allowedRoles.includes(role)) {
      // Неправильная роль, редирект на home
      return next({ name: 'Home' });
    }
  }

  next();
});

export default router
